// Capacity reporting: licence burn-down, volumes, database sizes, ETL runs. All read only.
import api from './api';

const code = (c) => encodeURIComponent(c);

export const reportingCapacityAPI = {
  burndown: () => api.get('/reporting/burndown'),
  burndownHistory: (custCode) => api.get(`/reporting/burndown/${code(custCode)}/history`),
  volumesSummary: () => api.get('/reporting/volumes/summary'),
  volumes: (custCode, dimension) => api.get(`/reporting/volumes/${code(custCode)}`, { params: { dimension } }),
  dbSizesSummary: () => api.get('/reporting/db-sizes/summary'),
  dbSizes: (custCode, dimension) => api.get(`/reporting/db-sizes/${code(custCode)}`, { params: { dimension } }),
  etlSummary: () => api.get('/reporting/etl/summary'),
  etlRuns: (limit = 100) => api.get('/reporting/etl/runs', { params: { limit } }),
  etlErrors: (limit = 100) => api.get('/reporting/etl/errors', { params: { limit } }),
};
